import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../../const/resource";
import { IProps } from './shippingmethodinterface';
import Loader from '../../../Loader';
import { ICartContextType } from '../../../ShoppingCart/ShoppingCartPromo/shoppingcartpromointerface';
import { useCartContext } from '../../../ShoppingCart/shoppingcart';
import { Error } from "@progress/kendo-react-labels";
import { TreeviewDropdown } from '../../../CommonComponent';
import partsService from "../../../../services/partsservice";
import helperfunctions from '../../../../utils/helperfunctions';
import Alerts from '../../../Alerts';

const ShippingMethod = (props: IProps) => {
    const { stepperDetails, cartsDetails }: ICartContextType = useCartContext();
    const { t } = useTranslation();
    const shippingMethodDiv = useRef<any>(null);
    const [showCarrierMsg, setShowCarrierMsg] = useState<boolean>(false);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [shippingCostResponse, setShippingCostResponse] = useState<any>({ loading: false, data: false });
    const showErrorMessage = (message: any) => {
        setErrorMessage(message);
        setShowAlert(true);
    }

    const handleErrorClose = () => {
        setErrorMessage('');
        setShowAlert(false);
    };

    useEffect(() => {
        if (stepperDetails?.shipment?.addressId > 0) {
            handleErrorClose();
        }
    }, [stepperDetails?.shipment?.addressId])

    useEffect(() => {
        if (stepperDetails?.shipment?.serviceTypeId > 0 && props?.shippingCarries?.data?.length > 0) {
            setShowCarrierMsg(false);
            props?.updateSelectedCarrier(props?.shippingCarries?.data?.find((t: any) => t.id == stepperDetails?.shipment?.serviceTypeId));
        } else if(!stepperDetails?.shipment?.serviceTypeId) {
            setShippingCostResponse({ loading: false, data: false });
        }
    }, [stepperDetails?.shipment?.serviceTypeId, props?.shippingCarries?.data])
    
    const fieldConditionMatchForShipping = (shipment: any, field: any) => {
        const value = shipment?.[field] ? shipment?.[field].toString() : ''
        return ((field !== 'addressId' && !value?.trim()?.length) || (field === 'addressId' && shipment?.[field] == null));
    }

    const phoneValidationForShippingMethod = (isValid: any) => {
        const shipment = stepperDetails?.shipment ?? {};
        const phoneValue = shipment?.phone ? shipment?.phone.replace(/\D/g, '') : '';
        const phoneCodeValue = shipment?.phoneCountryCode ?? "";
        if (phoneCodeValue?.length > 0 && phoneValue?.length == 0) {
            isValid = false;
        }
        if (phoneCodeValue?.length == 0 && phoneValue?.length > 0) {
            isValid = false;
        }
        if (phoneCodeValue == "+1" && phoneValue?.length > 0 && phoneValue?.length !== 10) {
            isValid = false;
        }

        return isValid;
    }

    const validationCheck = () => {
        const shipment = stepperDetails?.shipment ?? {};
        let requiredFields: any = [];
        let isValid = true;
        shipment['addressId'] = shipment['addressId'] ?? 0;
        requiredFields = [...requiredFields, 'addressId', 'firstName', 'lastName', 'address1', 'city', 'countryName', 'stateName', 'postalCode', 'phone', 'phoneCountryCode', 'attention'];
        requiredFields.forEach((field: any) => {
            if (fieldConditionMatchForShipping(shipment, field)) {
                shipment.error = { ...shipment.error, [field]: true };
                isValid = false;
            }
        });
        phoneValidationForShippingMethod(isValid);
        return isValid;
    };

    const getEstimatedCost = (serviceTypeId: any, extras: any) => {
        if (serviceTypeId <=0 ) {
            setShowCarrierMsg(true);
        }
        else if (validationCheck())
        {
            setLoading(true);
            handleErrorClose();
            setShippingCostResponse({ loading: true, data: false });
            setShowCarrierMsg(false);

            const model = {
                cartId: cartsDetails?.cart?.cartId,
                shippingCost: extras?.shippingcharges?.amount ?? 0,
            };
            partsService.calculateShippingCost(model)
                .then((response: any) => {
                    props.getItemSummaryDetailsWithoutLoading();
                    setShippingCostResponse({loading: false, data: response});
                    setLoading(false);
                })
                .catch((e: any) => {
                    showErrorMessage(e);
                    setLoading(false);
                    setShippingCostResponse({loading: false, data: false});
                });
        }
    }

    const onCarrierChange = (e: any, extra: any) => {
        if (stepperDetails?.shipment?.serviceTypeId != e) {
            props?.handleMethodChange(e, "serviceTypeId");
            props?.updateSelectedCarrier(extra?.triggerNode?.props);
            getEstimatedCost(e, extra?.triggerNode?.props);
        }
    }

    const onShippingMethodChange = (e: any) => {
        if (stepperDetails?.shipment?.shippingMethodId != e) {
            props?.handleMethodChange(e, "shippingMethodId");
            setShippingCostResponse({ loading: false, data: false });
            setShowCarrierMsg(false);
            props?.updateSelectedCarrier({});
        }
    }

    return (
        <div className='shippingMethodCard' ref={shippingMethodDiv}>
            {(shippingCostResponse?.loading || props?.shippingMethods?.loading || props?.shippingCarries.loading || loading) && <Loader />}
            <div className="shippinginfo_sub-header">{t(RESOURCE.MyK_Label_ShoppingCart_Shipping)}</div>
            {showAlert && (
                <Alerts
                    messageAlert={errorMessage}
                    alertType={'error'}
                    time={3000} onClose={() => handleErrorClose()}
                />
            )}

            {props?.shipmentDetails?.showShippingMethodWarning && <div className="ErrorMessage_Wrapper mt-2">
                <div className="ErrorMessage_card">
                    <span className="fa fa-exclamation-circle mr-1"></span>
                    <span>{t(RESOURCE.Myk_Label_SC_Shipping_Option_Warning)}</span>
                </div>
                </div>
             }

            {props?.shippingCarries?.data?.errors?.map((t: any) =>
                <div className="ErrorMessage_Wrapper mt-2" key={t['message']}>
                    <div className="ErrorMessage_card">
                        <span className="fa fa-exclamation-circle mr-1"></span>
                        <span className="shipping-err-category">{t['category']}: </span>
                        <span>
                            {t['message']}
                        </span>
                    </div>
                </div>
            )}

            {props?.shippingCarries?.data?.warnings?.map((t: any) =>
                <div className="ErrorMessage_Wrapper mt-2" key={t['message']}>
                    <div className="ErrorMessage_card">
                        <span className="fa fa-exclamation-circle mr-1"></span>
                        <span className="shipping-err-category">{t['category']}: </span>
                        <span>
                            {t['message']}
                        </span>
                    </div>
                </div>
            )}

            <div className="shippingcard">
                <div className="row mb-2">
                    <div className="col-12">
                        <div className="mb-1">
                            <label >{t(RESOURCE.MyK_Label_ShoppingCart_Select_Shipping_Method)}<span className="mandatory">*</span></label>
                        </div>
                        <div className="col-12 pl-0 pr-0" ref={props.mandatoryFieldRef}>
                            <TreeviewDropdown
                                dropdownClassName={'dropdownListContainer noNested'}
                                showSearch={true}
                                treeNodeFilterProp={"title"}
                                treeData={props?.shippingMethods?.data?.shippingMethodDetail ?? []}
                                value={props?.shipmentDetails?.shippingMethodId ?? ''}
                                onChange={(e: any) => {
                                    onShippingMethodChange(e);
                                }}
                            />
                            {(stepperDetails?.shipment?.error?.shippingMethodId) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_Shipping_Method_Req))}</Error>}
                            {(stepperDetails?.shipment?.error?.isReqForShippingMethod) && <Error> {String(t(RESOURCE.Myk_Label_SC_Shipping_Info_Required_Msg))}</Error>}
                        </div>
                    </div>
                </div>

                {(props?.shipmentDetails?.shippingMethodId && props?.shippingCarries?.data?.carriers?.length > 0) &&
                    <>
                        <div className="row mb-2">
                            <div className="col-12">
                            <div className="mb-1">
                                <label>{t(RESOURCE.MyK_Label_SC_Select_Carrier)}</label>
                                </div>
                                <div className="col-12 pl-0 pr-0">
                                    <TreeviewDropdown
                                        dropdownClassName={'dropdownListContainer noNested'}
                                        showSearch={true}
                                        treeData={props?.shippingCarries?.data?.carriers ?? []}
                                        placeholder={""}
                                        treeNodeFilterProp={"title"}
                                        value={stepperDetails?.shipment?.serviceTypeId || ""}
                                        onChange={(e: any, _: any, extra: any) => {
                                            onCarrierChange(e, extra);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        {showCarrierMsg && <div className="mb-2">
                            <div className="ErrorMessage_Wrapper">
                                <div className="ErrorMessage_card">
                                <span className="fa fa-exclamation-circle mr-1"></span> <span>
                                    {t(RESOURCE.MyK_Label_SC_Carrier_Selection_Warning)}
                                    </span>
                                </div>
                            </div>
                        </div>
                        }

                    {(!props?.shipmentDetails?.showShippingMethodWarning) && <div className="float-right">
                        <span className="estimated-cost mr-1" onKeyDown={() => { }}>{t(RESOURCE.MyK_Label_ShoppingCart_Estimated_Cost)} : </span>
                        <span className="estimated-cost-value">{props?.selectedCarrier?.shippingcharges?.amount > 0 ? "$"+helperfunctions.formatAmount(props?.selectedCarrier?.shippingcharges?.amount) :''}</span>
                        </div>}
                    </>
                }
            </div>

        </div>
    )
}

export default ShippingMethod